import { Button, Intent, MenuItem } from "@blueprintjs/core";
import { ItemRenderer, MultiSelect2 } from "@blueprintjs/select";
import _ from "lodash";
import React from "react";
import { UserLanguage } from "../../lang/lang";
import { _p, _p2 } from "../../utils/pack";

interface ISProps<T> {
  items: Array<T> | null;
  defaultItems?: Array<T>;
  itemRenderer: ItemRenderer<T>;
  tagKey?: keyof T;
  onSelectionChange: (items: T[]) => Promise<void>;
  translate?: (i: T) => string;
  intent?: (i: T) => Intent;
}

interface ISState<T> {
  selectedItems: T[];
}

export class ItemSelect<T> extends React.Component<ISProps<T>, ISState<T>> {
  constructor(props: ISProps<T>) {
    super(props);

    this.state = {
      selectedItems: props.defaultItems || [],
    };
  }

  private get_string(i: T) {
    if (this.props.translate) {
      return this.props.translate(i);
    } else if (this.props.tagKey) {
      return i[this.props.tagKey];
    }
    return i;
  }

  private get_item_by_tag(tag: React.ReactNode) {
    return _.find(this.state.selectedItems, (i) => tag === this.get_string(i));
  }

  render() {
    const _this = this;

    return (
      <MultiSelect2<T>
        items={
          this.props.items
            ? _.difference(this.props.items, this.state.selectedItems)
            : []
        }
        itemRenderer={this.props.itemRenderer}
        onItemSelect={(i) =>
          _p(_.concat(this.state.selectedItems, i))
            .then((i) => _p2(i, (i) => this.props.onSelectionChange(i)))
            .then((i) => _this.setState({ selectedItems: i }))
        }
        tagRenderer={(item) => this.get_string(item)}
        tagInputProps={{
          onRemove: (_tag: React.ReactNode) =>
            _p(
              _.remove(
                this.state.selectedItems,
                (t) => this.get_string(t) !== _tag
              )
            )
              .then((i) => _p2(i, (i) => this.props.onSelectionChange(i)))
              .then((i) => _this.setState({ selectedItems: i })),
          tagProps: (_tag: React.ReactNode) => {
            if (!this.props.intent) return { intent: Intent.NONE };
            const item = this.get_item_by_tag(_tag);
            if (item) {
              return { intent: this.props.intent(item) };
            }
            return { intent: Intent.NONE };
          },
        }}
        selectedItems={this.state.selectedItems}
        noResults={<MenuItem text={UserLanguage().errors.no_items} disabled />}
      >
        <Button></Button>
      </MultiSelect2>
    );
  }
}
